var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Alert, Box, DialogContent, DialogFooter, DialogHeader, Typography, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useHistory } from 'react-router-dom';
import { useSearchContext } from 'app/domains/global-search';
import { CompanyRoleEnum2 } from 'shared/domains/apollo/generated/types';
import { TextField, FormDialog, CancelButton, SubmitButton, TextAreaField, SwitchField } from 'shared/domains/forms';
import { useAccount } from 'shared/domains/users';
import { makeSchema } from './schema';
import { useSaveViewMutation } from './useSaveViewMutation';
export function SaveViewDialog(props) {
    const { onClose } = props;
    const { addToast } = useToast();
    const history = useHistory();
    const account = useAccount();
    const { role } = account.data;
    const isOwner = role === CompanyRoleEnum2.Owner;
    const { values } = useSearchContext();
    const { saveView, error } = useSaveViewMutation();
    const schema = makeSchema();
    const handleSubmit = (formValues) => __awaiter(this, void 0, void 0, function* () {
        try {
            const { data } = yield saveView(formValues, values);
            history.push(`/saved-view/${data === null || data === void 0 ? void 0 : data.createSearchCustomView.id}`);
            addToast({
                title: t({ message: 'Successfully created view', comment: 'Save view success toast' }),
                appearance: 'success',
            });
        }
        catch (e) {
            addToast({
                title: t({ message: 'Failed to save view', comment: 'Save view error toast' }),
                appearance: 'danger',
            });
        }
    });
    return (<FormDialog onClose={onClose} initialValues={{ name: '', description: '', isPublic: false }} validationSchema={schema} onSubmit={handleSubmit} validateOnMount>
      <DialogHeader title={t({ message: 'Save view', comment: 'Save view dialog header title' })} icon={<Falcon icon="bookmark"/>}/>
      <DialogContent>
        <Box mb="2xl">
          <Typography>
            <Trans comment="Save custom search view note">
              Save your filtered view to quickly access it from the main menu later.
            </Trans>
          </Typography>
        </Box>

        <Box flexDirection="column" gap="md" mb="2xl">
          <TextField autoFocus label={t({ message: 'Name', comment: 'Create saved view: name label', context: 'saved-views' })} name="name"/>

          <TextAreaField label={t({
            message: 'Description',
            comment: 'Create saved view: description label',
            context: 'saved-views',
        })} name="description"/>
        </Box>

        {isOwner && (<SwitchField name="isPublic" icon={<Falcon icon="eye"/>} title={t({
                message: 'Public',
                comment: 'Saved views: Settings dialog form label',
            })} subtitle={t({
                message: 'Setting this view as public will make it available for all users in the company.',
                comment: 'Saved views: Settings dialog public description',
            })}/>)}

        {error && (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please try again later.',
                comment: 'Failed to do something error message',
            })}/>)}
      </DialogContent>

      <DialogFooter>
        <CancelButton size="small" onClick={onClose}>
          <Trans comment="Cancel button text">Cancel</Trans>
        </CancelButton>
        <SubmitButton size="small">
          <Trans comment="Save view button label">Save view</Trans>
        </SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
